<template>
    <div role="main" class="main rate">
        <div class="container">
            <div class="row mt-5">
                <div class="col-sm-12 mx-md-auto text-center">
                    <h2 class="font-weight-normal text-9 text-uppercase justify-center mb-4 pb-3 pt-2">Rate lecture</h2>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 mx-md-auto text-center">
                    <p class="title text-6 font-weight-bold">{{ lecture.name }}</p>
                    <p class="authors text-5">
                        <span v-for="author in authors" :key="author.id" class="author">
                            {{ author.first_name }} {{ author.last_name }}<span>,</span>
                        </span>
                    </p>
                </div>
            </div>
            <div class="row mt-5">
                <div class="col-sm-12 mx-md-auto text-center">
                    <h3 class="font-weight-bold text-6 text-uppercase justify-center mb-4">Overall impression</h3>
                    <div class="like-lecture">
                        <div>
                            <input type="radio" id="likeLecture-0" value="0" v-model="likeLecture" />
                            <label for="likeLecture-0">
                                <span>
                                    <em></em>
                                </span>
                            </label>
                        </div>
                        <div>
                            <input type="radio" id="likeLecture-1" value="1" v-model="likeLecture" />
                            <label for="likeLecture-1">
                                <span>
                                    <em></em>
                                </span>
                            </label>
                        </div>
                    </div>
                </div>

            </div>
            <div class="row mt-5">
                <div class="col-sm-12 mx-md-auto text-center">
                    <h3 class="font-weight-bold text-6 text-uppercase justify-center mb-4">Speakers</h3>
                    <div class="like-speakers">
                        <symbol id="icon-star" class="icon" viewBox="0 0 60.64 57.905">
                            <defs>
                                <rect id="SVGID_1_" y="0" width="32" height="32"/>
                            </defs>
                            <clipPath id="SVGID_2_">
                                <use xlink:href="#SVGID_1_"  overflow="visible"/>
                            </clipPath>
                            <path clip-path="url(#SVGID_2_)" d="M32.459,1.33l7.521,15.239c0.349,0.704,1.021,1.193,1.796,1.306l16.818,2.443
                                c1.957,0.284,2.739,2.69,1.323,4.07L47.747,36.25c-0.563,0.548-0.819,1.338-0.687,2.11l2.873,16.75
                                c0.334,1.949-1.712,3.437-3.462,2.516L31.43,49.718c-0.695-0.366-1.525-0.366-2.221,0l-15.042,7.908
                                c-1.75,0.921-3.795-0.566-3.461-2.516l2.873-16.75c0.132-0.772-0.124-1.563-0.686-2.11L0.723,24.388
                                c-1.416-1.38-0.635-3.786,1.322-4.07l16.818-2.443c0.777-0.113,1.449-0.602,1.796-1.306L28.181,1.33
                                C29.056-0.442,31.584-0.442,32.459,1.33"/>
                        </symbol>
                        <rate class="RateCustom" :length="5" :value="3" :ratedesc="desc" iconref="icon-star" v-model="myRate" />
                    </div>
                </div>
            </div>
            <div class="row mt-5">
                <div class="col-sm-12 mx-md-auto text-center">
                    <h3 class="font-weight-bold text-6 text-uppercase justify-center mb-4">Lecture content</h3>
                    <div class="like-content">
                        <rate class="RateCustom" :length="5" :value="3" :ratedesc="desc" iconref="icon-star" v-model="myRate2" />
                    </div>
                </div>
            </div>
            <div class="row mt-5">
                <div class="col-sm-12 mx-md-auto text-center">
                    <h3 class="font-weight-bold text-6 text-uppercase justify-center mb-4">Something more?</h3>
                    <div class="like-content">
                        <textarea v-model="comment" placeholder="Comment here..." />
                    </div>
                </div>
            </div>
            <div class="row mt-5 actions">
                <div class="col-sm-12 mx-md-auto text-center">
                    <button class="submit btn btn-primary btn-modern">rate</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    name: 'RateView',
    components: {
        
    },
    data(){
        return{
            myRate: 0,
            myRate2: 0,
            comment: '',
            likeLecture: null,
            authors: '',
            authorsTemp: '',
            lecture: '',
            slug: this.$route.params.id,
        }
    }, 
    methods:{
        getName(){
            axios.get(process.env.VUE_APP_BASE_URL+'/codedive/items/lecture?fields=*.*&filter[slug]='+this.$route.params.id)
                .then(response => {
                    this.lecture = response.data.data[0];
                })
                .then(response => {
                    for(let i = 0; i < this.lecture.lecture_authors.length;i++){
                        this.authorsTemp += this.lecture.lecture_authors[i].authors_id+ ','
                    }                    
                })
                .then(response => {
                    axios.get(process.env.VUE_APP_BASE_URL+'/codedive/items/authors?filter[id][in]='+this.authorsTemp)
                        .then(response => {
                            this.authors = response.data.data;
                        })
                })
        },
    },
    beforeMount(){
        this.getName();
    },
}
</script>

<style lang="scss">
    @import '@/assets/sass/variables.scss';
    @import '@/assets/sass/rate.scss';
</style>